'use client';
import { useState } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import { useAgentRegistry } from '../../apps/hooks/agent/useAgentRegistry';
import { AgentPersonaTab } from './components/AgentPersonaTab';
import { ManualTab } from './components/ManualTab';
import { PageHeader } from './components/PageHeader';

export default function AgentRegistryPage() {
  const [activeTab, setActiveTab] = useState<'agents' | 'manuals'>('agents');
  const { registryTreeQuery } = useAgentRegistry();

  return (
    <Container className="py-4">
      <PageHeader
        title="AI Agent Registry"
        subtitle="Manage Supervisor Agents, Micro Agents, and Manuals"
      />

      {registryTreeQuery.error && (
        <div className="alert alert-danger" role="alert">
          Failed to load registry tree
        </div>
      )}

      <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k as 'agents' | 'manuals')} className="mb-4">
        <Tab eventKey="agents" title="Agent Personas">
          <AgentPersonaTab registryTree={registryTreeQuery.data} />
        </Tab>
        <Tab eventKey="manuals" title="Manuals">
          <ManualTab registryTree={registryTreeQuery.data} />
        </Tab>
      </Tabs>
    </Container>
  );
}

